export default __webpack_public_path__ + "static/media/photo-grid.294d59b6.png";